// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"a0cd35e6","118":"41655bd5","233":"e0300a19","240":"7b991303","453":"68693753","523":"2a95cf28","587":"ce24dc1a","597":"02eebe0d","659":"33310df8","695":"282eb06a","858":"4b5062a3","871":"c07c498c","950":"e5df93ad","989":"9d4ddfeb"}[chunkId] + ".chunk.js";
};